<template>
  <v-dialog :value="fetching" persistent max-width="440">
    <v-card dark class="mail-loader-card" role="status" aria-live="polite">
      <div class="loader-visual">
        <div class="loader-halo"></div>
        <v-progress-circular indeterminate color="#009640" size="64" width="5"></v-progress-circular>
        <v-icon class="loader-icon" size="22">mdi-email-sync-outline</v-icon>
      </div>

      <div class="loader-eyebrow">Postfach wird synchronisiert</div>
      <h2>Neue Dokumente werden geladen</h2>
      <p>Wir prüfen den Mailserver und verarbeiten neue Nachrichten sowie Anhänge. Das kann einen Moment dauern.</p>

      <div class="loader-note">
        <v-icon small>mdi-shield-check-outline</v-icon>
        <span>Das Fenster schließt sich automatisch, sobald die Verarbeitung abgeschlossen ist.</span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"

export default {
  name: "DocumentEmailFetcher",
  data() {
    return {
      fetching: false,
    }
  },
  methods: {
    async fetchMails() {
      this.fetching = true
      try {
        const response = await api.documents.fetchDocumentEmails()
        this.$toast.success(`${response.message} Neue Mails: ${response.newMails}, Neue Anhänge: ${response.newAttachments}`)
        if (parseInt(response.newAttachments) > 0 || parseInt(response.newMails) > 0) this.$emit("newAttachements")
      } catch (e) {
        this.$toast.error("Fehler beim Laden der E-Mails")
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>

<style scoped>
.mail-loader-card {
  --loader-bg: rgba(28, 28, 29, 0.97);
  --loader-border: rgba(255, 255, 255, 0.11);
  --loader-text: #f5f5f5;
  --loader-muted: #a3a3a3;
  display: flex;
  padding: 34px 30px 28px;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  border: 1px solid var(--loader-border);
  border-radius: 22px !important;
  background: var(--loader-bg) !important;
  backdrop-filter: blur(22px);
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.46);
  text-align: center;
}

.loader-visual {
  position: relative;
  display: grid;
  width: 86px;
  height: 86px;
  margin-bottom: 18px;
  place-items: center;
}

.loader-halo {
  position: absolute;
  inset: 0;
  border: 1px solid rgba(0, 150, 64, 0.2);
  border-radius: 27px;
  background: rgba(0, 150, 64, 0.08);
  transform: rotate(7deg);
}

.loader-icon {
  position: absolute;
  color: #65c98f !important;
}

.loader-eyebrow {
  margin-bottom: 6px;
  color: #65c98f;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.mail-loader-card h2 {
  margin: 0;
  color: var(--loader-text);
  font-size: 1.13rem;
  font-weight: 800;
  letter-spacing: -0.015em;
}

.mail-loader-card > p {
  max-width: 360px;
  margin: 9px 0 0;
  color: var(--loader-muted);
  font-size: 0.8rem;
  line-height: 1.65;
}

.loader-note {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  margin-top: 22px;
  padding: 12px 13px;
  border: 1px solid rgba(0, 150, 64, 0.18);
  border-radius: 14px;
  background: rgba(0, 150, 64, 0.055);
  color: #d4d4d4;
  font-size: 0.7rem;
  line-height: 1.45;
  text-align: left;
}

@media (max-width: 599px) {
  .mail-loader-card {
    margin: 8px;
    padding: 29px 22px 22px;
    border-radius: 20px !important;
  }
}
</style>
